import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import loadable from '@loadable/component';

// AE-specific account pages
const LoginPageAE = loadable(() => import(/* webpackChunkName: "LoginPageAE" */ '~/app/pages/ae/LoginPage'));
const ForgotPasswordPageAE = loadable(() => import(/* webpackChunkName: "ForgotPasswordPageAE" */ '~/app/pages/ae/ForgotPasswordPage'));
const ResetPasswordPageAE = loadable(() => import(/* webpackChunkName: "ResetPasswordPageAE" */ '~/app/pages/ae/ResetPasswordPage'));
const SignOutPageAE = loadable(() => import(/* webpackChunkName: "SignOutPageAE" */ '~/app/pages/ae/SignOutPage'));

const AEAccountRouter = () => (
  <Switch>
    <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.LOGIN}`} component={LoginPageAE} />    
    <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.FORGOT_PASS}`} component={ForgotPasswordPageAE} />    
    <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.RESET_PASS}`} component={ResetPasswordPageAE} />    
    <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.LOGOUT}`} component={SignOutPageAE} />
    <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.ACCOUNT}`}>
      <Redirect to={`/:locale(ae_ar|ae_en)${PATHS.MY_FF}`} />
    </Route>
    
    <Redirect to="/:locale(ae_ar|ae_en)/404" />
  </Switch>
);

export default AEAccountRouter;
